import { render, staticRenderFns } from "./PostingList.vue?vue&type=template&id=1d227a0c"
import script from "./PostingList.vue?vue&type=script&lang=js"
export * from "./PostingList.vue?vue&type=script&lang=js"
import style0 from "./PostingList.vue?vue&type=style&index=0&id=1d227a0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports